import { render, staticRenderFns } from "./SearchServiceSearch.vue?vue&type=template&id=0839ff48"
import script from "./SearchServiceSearch.vue?vue&type=script&lang=js"
export * from "./SearchServiceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports